const defaultState = {};

const mutations = {
    setAnalysisTypeState(state, analysisType) {
        Object.assign(state, analysisType);
    },
    resetAnalysisTypeState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getAnalysisTypeInfo({ commit, dispatch }, analysisTypeId) {
        try {
            const { data } = await this.$rq.getAnalysisType(analysisTypeId);
            commit('setAnalysisTypeState', data);
        } catch (err) {
            dispatch('resetAnalysisTypeInfo');
        }
    },
    resetAnalysisTypeInfo({ commit }) {
        commit('resetAnalysisTypeState');
    },
};

const getters = {
    analysisType: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
